import { useState } from "react";
import { Divider, Grid, Icon, IconButton } from "@mui/material";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import Drawer from "ui-components/Drawer";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Fieldset, Texts } from "ui-components/Form";
import { LoadingDialog } from "ui-components/Alert";
import { getDOLog, editDOTSmallCarton } from "services/data.outbound.service";

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Customer Order No", id: "custOrdNbr" },
  { label: "Quantity", id: "quantity" },
  { label: "Base UOM", id: "baseUOM" },
];

function DOLog({ open, setOpen, logRequest, setLogRequest }) {
  const queryClient = useQueryClient();
  const [edit, setEdit] = useState(false);
  const [tSmallCarton, setTSmallCarton] = useState(null);

  const { data: doData } = useQuery({
    queryKey: ["do-log", { logRequest }],
    queryFn: () => getDOLog(logRequest),
    enabled: Boolean(logRequest),
  });

  const item = doData?.data.data;

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setEdit(false);
    setTSmallCarton(null);
    setLogRequest(null);
  };

  const editMutation = useMutation(editDOTSmallCarton, {
    onSuccess: () => {
      queryClient.invalidateQueries(["do-log"]);
      setEdit(false);
      setTSmallCarton(null);
    },
  });
  const onSubmit = () => {
    editMutation.mutate({
      delOrderId: logRequest.delOrderId,
      tSmallCarton: tSmallCarton === null || tSmallCarton === "" ? null : Number(tSmallCarton),
    });
  };
  const editStatus = editMutation.status === "loading";

  return (
    <Drawer width="1400px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {editStatus && <LoadingDialog />}
      <MDTypography variant="h5" color="info">
        Delivery Order{" "}
        {Boolean(item) && (
          <IconButton
            sx={{ width: "1rem", height: "1rem" }}
            color="success"
            onClick={() => {
              setTSmallCarton(item.tSmallCarton ?? "");
              setEdit(true);
            }}
          >
            <Icon>edit</Icon>
          </IconButton>
        )}
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {Boolean(item) && (
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={3}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={3}>
                <b>DO Number : </b>
                {item.doNumber}
              </Grid>
              <Grid item xs={3}>
                <b>DO Date : </b>
                {item.doDate}
              </Grid>
              <Grid item xs={3}>
                <b>Warehouse Code : </b>
                {item.warehouseCode}
              </Grid>
              <Grid item xs={3}>
                <b>Total Carton : </b>
                {item.tSmallCarton}
              </Grid>
            </Grid>
            {edit && (
              <Fieldset label="Edit">
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={2}>
                    <Texts
                      field={{ name: "", label: "Total Carton", value: tSmallCarton, errors: {} }}
                      onChange={(e) => setTSmallCarton(e.target.value)}
                    />
                  </Grid>
                  <Grid item>
                    <MDButton color="info" onClick={onSubmit}>
                      Submit
                    </MDButton>
                  </Grid>
                  <Grid item>
                    <MDButton
                      color="secondary"
                      onClick={() => {
                        setEdit(false);
                        setTSmallCarton(null);
                      }}
                    >
                      Cancel
                    </MDButton>
                  </Grid>
                </Grid>
              </Fieldset>
            )}
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.details} />
          </div>
          <TimelineList title="Logs">
            {item.logs.map(({ id, ...log }) => (
              <TimelineItem key={id} {...log} />
            ))}
          </TimelineList>
        </>
      )}
    </Drawer>
  );
}

export default DOLog;
